import styled, { css } from 'vue3-styled-components';

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #cc5803;
`;

export const SearchInput = styled.input`
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    height: 20px;
    width: 250px;

    &:focus {
        outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 5px rgba(0, 102, 204, 0.5);
    }
`;

export const OxygenTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;

    th, td {
        padding: 10px;
        text-align: center;
        border: 1px solid #ddd;
        cursor: pointer;
    }

    th {
        background-color: #fb8b24;
        font-weight: bold;
    }

    tbody tr:hover {
        background-color: #eaeaea;
    }

    col:nth-child(1) { width: 6%; }     // 순번
    col:nth-child(2) { width: 15%; }    // 관리번호
    col:nth-child(3) { width: 18%; }    // 제품명
    col:nth-child(4) { width: 10%; }    // 상태
    col:nth-child(5) { width: 8%; }     // 구분
    col:nth-child(6) { width: 8%; }     // 급여/비급여
    col:nth-child(7) { width: 8%; }     // 대여자명
    col:nth-child(8) { width: 13%; }    // 대여시작일
    col:nth-child(9) { width: 13%; }    // 대여종료일
    col:nth-child(10) { width: 6%; }     // 등록해제
`;

export const StatusBadge = styled.span`
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
    
    ${props => {
        switch (props.status) {
            case 'rented':
                return 'background-color: #ffd700; color: #000;';
            case 'available':
                return 'background-color: #90EE90; color: #000;';
            case 'maintenance':
                return 'background-color: #ff6b6b; color: #fff;';
            default:
                return 'background-color: #gray; color: #000;';
        }
    }}
`;

export const StyledTableRow = styled.tr`
    cursor: pointer;

    ${props => props.status === '매장' && css`
        background-color: #e8f5e9;
    `}

    ${props => props.status === '급여' && css`
        background-color: #fff8e1;
    `}

    ${props => props.status === '비급여' && css`
        background-color: #e3f2fd;
    `}

    ${props => props.status === '기초수급자' && css`
        background-color: #ffebee;
    `}
`;

export const TableContainer = styled.div`
    margin-top: 20px;
    overflow-x: auto;
    margin-bottom: 20px;
    margin-right: 10px;
`;

export const RegisterButton = styled.button`
    padding: 10px 12px;
    background-color: #0f4c5c;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    
    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const DeleteButton = styled.button`
    cursor: pointer;
    color: #ff4444;
    font-size: 30px;
    font-weight: bold;
    border: none;
    background: none;
    padding: 0 8px;

    &:hover {
        color: #cc0000;
    }
`;

export const SearchSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    margin-right: 10px;
    gap: 8px;
`;